import { useQuery } from '@tanstack/react-query';

import { getAllStates, getStates } from '@src/requests/states';

const useStatesQuery = (opts = {}) => {
    return useQuery({
        queryKey: ['states'],
        queryFn: getStates,
        staleTime: Infinity,
        ...opts,
    });
};

const useAllStatesQuery = (opts = {}) => {
    return useQuery({
        queryKey: ['all-states'],
        queryFn: getAllStates,
        staleTime: Infinity,
        ...opts,
    });
};

export { useAllStatesQuery, useStatesQuery };
